<template>
  <div class="ssh-container">
    <div class="ssh-header">
      <div class="ssh-header-container">
        <div class="ssh-header-container-inner content-width">
          <span class="ssh-header-inner-top">
            云南省妇科医疗质量控制中心
          </span>
          <ul class="ssh-header-inner-top-btn">
            <!--            <li @click="openDialog('system')">-->
            <!--              <i class="el-icon-question"></i>-->
            <!--              <span>系统使用说明</span>-->
            <!--            </li>-->
            <li @click="openDialog('tell')">
              <i class="el-icon-chat-line-round"></i>
              <span>联系我们</span>
            </li>

          </ul>
        </div>
      </div>
      <div class="ssh-nav-menu">
        <div class="content-width">
          <el-menu :default-active="activeMenu" class="ssh-nav" background-color="#193871" text-color="#fff"
            active-text-color="#fff" mode="horizontal" @select="handleSelect">
            <SidebarItem v-for="route in menuList" :key="route.path" :item="route"></SidebarItem>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="ssh-main content-width">
      <router-view />
    </div>
    <div class="ssh-footer">
      <div class="ssh-footer-content">
        <div class="ssh-footer-content-bgc">
          <ul class="ssh-footer-content-container content-width">
            <li class="ssh-footer-content-left">
              <div class="ssh-footer-content-right-list-tell" style="font-size: 24px">云南省妇科医疗质量控制中心</div>
              <div class="ssh-footer-content-right-list-tell" style="font-size: 14px">挂靠单位:云南省第一人民医院
              </div>
            </li>
            <li>
              <div class="ssh-footer-content-info">
                <i class="el-icon-phone"></i>
                <span>联系电话：</span>
                <b>(0871) 6362 5045 </b>

              </div>
              <div class="ssh-footer-content-info">
                <i class="el-icon-location-outline"></i>
                <span>公司地址：</span>
                <b>云南省昆明市西山区金碧路157号</b>

              </div>
              <div class="ssh-footer-content-info">
                <i class="el-icon-message"></i>
                <span>联系邮箱：</span>
                <b>2573089102@qq.com</b>
              </div>
            </li>
            
          </ul>
        </div>

      </div>
      <div class="ssh-footer-link-container">
        <ul class="ssh-footer-link content-width">
          <li class="ssh-footer-content-left-code">
            <a target="_blank" href="http://beian.miit.gov.cn">滇ICP备15003244号 备案号：5301000000702</a>
            <img width="18" style="vertical-align: -7px" :src="imgGuohui" />
          </li>
          <li>
            Copyright 1998 - 2021 Tencent. All Rights Reserved
          </li>
        </ul>
      </div>

    </div>
    <el-dialog :title="dialogType == 'system' ? '系统使用说明' : '联系我们'" :visible.sync="sendDialog" center width="320px"
      :close-on-click-modal="false" :before-close="handleClose">
      <div v-if="dialogType == 'system'">
        系统说明：
        <ol>
          <li>登录系统</li>
          <li>点击上报数据</li>
          <li>查看上报数据</li>
        </ol>
      </div>
      <div v-else>
        联系我们：
        <ol>
          <li>联系电话：(0871) 6362 5045 </li>
          <li>联系邮箱：2573089102@qq.com</li>
        </ol>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import SidebarItem from './SidebarItem.vue'
import imgGuohui from '../../assets/guohui.png'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: "home",
  components: {
    SidebarItem
  },
  data() {
    return {
      imgGuohui,
      activeFriendsLink: 'industry',
      menuList: [],
      sendDialog: false,
      dialogType: 'system'
    }
  },
  computed: {
    ...mapGetters([
      'activeMenu'
    ])
  },
  mounted() {
    this.menuList = this.$router.options.routes[0].children.filter(art => !art.hidden)
  },
  methods: {
    handleSelect(path) {
      this.$store.dispatch('menuPath/getActiveMenu', path)
    },
    handleClose() {
      this.sendDialog = false
    },
    openDialog(dialogType) {
      this.sendDialog = true
      this.dialogType = dialogType
    }
  }
}
</script>

<style scoped>

</style>
